/** Ein Stück Kommentartext: Klartext oder eine Adresse, die zum Link wird. */
export type CommentPiece = { kind: 'text'; text: string } | { kind: 'link'; text: string; href: string }

/*
  Nur `http://` und `https://` — nichts, was ein Protokoll mitbringt, das die App ausführen
  könnte. Satzzeichen am Ende gehören zum Satz, nicht zur Adresse („siehe https://x.de.").
*/
const URL_PATTERN = /https?:\/\/[^\s<>"]+/g
const TRAILING = /[.,;:!?)\]}'"»“”]+$/

/**
 * **Reiner Text mit klickbaren Adressen** (#183, „erstmal"): zerlegt den Kommentar in Stücke.
 * Zeilenumbrüche bleiben im Text; dargestellt werden sie per `white-space: pre-wrap`.
 */
export function splitCommentText(content: string): CommentPiece[] {
  const pieces: CommentPiece[] = []
  let rest = 0
  for (const match of content.matchAll(URL_PATTERN)) {
    const raw = match[0]
    const href = raw.replace(TRAILING, '')
    const start = match.index
    if (start > rest) pieces.push({ kind: 'text', text: content.slice(rest, start) })
    pieces.push({ kind: 'link', text: href, href })
    rest = start + href.length
  }
  if (rest < content.length) pieces.push({ kind: 'text', text: content.slice(rest) })
  return pieces
}
